// App.js
import { Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import Home from './Pages/Home';
import KnowYourRights from './Pages/KnowYourRights';
// import AboutUs from './Pages/AboutUs';

const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    // usar replace para no dejar historial en la SPA
    window.location.replace(to);
  }, [to]);
  return null;
};

const App = () => {
  return (
      <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tarjeta-verde" element={<KnowYourRights />} />
        {/* <Route path="/about-us" element={<AboutUs />} /> */}
        <Route path="*" element={<ExternalRedirect to="https://donate.odamexico.org" />} />
      </Routes>
      </>
  );
};

export default App;